import React from 'react'
import Heading from './projectGridCell/Heading'
import DiscoverMore from './projectGridCell/DiscoverMore'

const Project = () => {
  return (
    <section id='project'>
      <div className='grid w-full h-full grid-cols-3 gap-3 pr-3' style={{ 'grid-template-rows': '1fr 1fr 1fr 1fr' }}>
        <div className='p-3 home-grid-cell'><Heading/></div>
        <div className='row-span-3 p-3 home-grid-cell'>Content 2</div>
        <div className='row-span-2 p-3 home-grid-cell'>Content 6</div>
        <div className='row-span-2 p-3 home-grid-cell'>Content 3</div>
        <div className='row-span-2 p-3 home-grid-cell'><DiscoverMore/></div>
        <div className='col-span-2 p-3 home-grid-cell'>Content 5</div>
      </div>
    </section>
  )
}

export default Project